var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9543 47.5C34.9546 50.2614 32.717 52.5 29.9563 52.5C27.1956 52.5 24.9572 50.2614 24.9569 47.5C24.9564 44.7386 27.194 42.5 29.9548 42.5C32.7155 42.5 34.9538 44.7386 34.9543 47.5Z",
    fill: "#D7A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24924 21.3753C4.37373 19.843 4.67323 17.8924 6.06959 16.8134C12.1021 12.1521 20.0786 8.75 29.9991 8.75C39.9198 8.75 47.8963 12.1521 53.9286 16.8134C55.325 17.8924 55.6245 19.8431 54.749 21.3753L53.5213 23.5238C52.3464 25.5799 49.5869 26.0336 47.641 24.6838C42.8939 21.3905 36.8656 18.75 29.9991 18.75C23.1326 18.75 17.1044 21.3905 12.3572 24.6838C10.4114 26.0336 7.65192 25.5799 6.47695 23.5238L5.24924 21.3753Z",
    fill: "#D7A1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5159 35.1499C14.4971 33.6216 14.7136 31.5489 16.1941 30.462C19.7091 27.882 23.965 26.25 29.9993 26.25C36.0336 26.25 40.2895 27.882 43.8044 30.462C45.285 31.5489 45.5015 33.6216 44.4828 35.1499L43.2904 36.9382C42.221 38.5425 39.9549 38.7995 38.293 37.8224C36.0978 36.5318 33.2191 35.4444 29.9993 35.4444C26.7795 35.4444 23.9009 36.5318 21.7056 37.8224C20.0438 38.7995 17.7776 38.5425 16.7081 36.9382L15.5159 35.1499Z",
    fill: "#D7A1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9536 47.5C34.954 50.2614 32.7164 52.5 29.9556 52.5C27.195 52.5 24.9566 50.2614 24.9562 47.5C24.9557 44.7386 27.1934 42.5 29.9541 42.5C32.7149 42.5 34.9531 44.7386 34.9536 47.5Z",
    stroke: "#61298A",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25015 21.3753C4.37465 19.843 4.67415 17.8924 6.0705 16.8134C12.103 12.1521 20.0796 8.75 30.0001 8.75C39.9206 8.75 47.8971 12.1521 53.9296 16.8134C55.3259 17.8924 55.6254 19.8431 54.7499 21.3753L53.5222 23.5238C52.3472 25.5799 49.5878 26.0336 47.642 24.6837C42.8948 21.3905 36.8666 18.75 30.0001 18.75C23.1336 18.75 17.1054 21.3905 12.3581 24.6837C10.4123 26.0336 7.65282 25.5799 6.47786 23.5238L5.25015 21.3753Z",
    stroke: "#61298A",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5165 35.1499C14.4976 33.6216 14.7143 31.5489 16.1948 30.462C19.7098 27.882 23.9655 26.25 29.9999 26.25C36.0343 26.25 40.2901 27.882 43.805 30.462C45.2856 31.5489 45.5021 33.6216 44.4834 35.1499L43.291 36.9383C42.2216 38.5425 39.9555 38.7995 38.2935 37.8224C36.0984 36.5318 33.2198 35.4444 29.9999 35.4444C26.7801 35.4444 23.9015 36.5318 21.7063 37.8224C20.0444 38.7995 17.7783 38.5425 16.7088 36.9383L15.5165 35.1499Z",
    stroke: "#61298A",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLan);
export default __webpack_public_path__ + "static/media/lan.b6ff8d45413c71b4c96e5dd83972ac03.svg";
export { ForwardRef as ReactComponent };